import { TreatmentPeriods, ViewClaimFilters } from 'all-in-one-shared-api';
import { Select } from 'antd';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Option {
  label: string;
  value: string;
}

interface TreatmentPeriodDropdownProps {
  onChange: React.Dispatch<React.SetStateAction<ViewClaimFilters>>;
}

const { Option } = Select;

interface TreatmentPeriodOption {
  label: string;
  value: TreatmentPeriods | '';
}

const TreatmentPeriodDropdown: FC<TreatmentPeriodDropdownProps> = ({ onChange }) => {
  const { t } = useTranslation();
  const [selectedTreatmentPeriod, setSelectedTreatmentPeriod] = useState<TreatmentPeriods | ''>();

  const treatmentPeriodOptions: TreatmentPeriodOption[] = [
    {
      label: t('enum.treatmentPeriod.ALL_TIME'),
      value: '',
    },
    {
      label: t('enum.treatmentPeriod.LAST_WEEK'),
      value: 'LAST_WEEK',
    },
    {
      label: t('enum.treatmentPeriod.LAST_30_DAYS'),
      value: 'LAST_30_DAYS',
    },
    {
      label: t('enum.treatmentPeriod.THIS_POLICY_YEAR'),
      value: 'THIS_POLICY_YEAR',
    },
    {
      label: t('enum.treatmentPeriod.LAST_POLICY_YEAR'),
      value: 'LAST_POLICY_YEAR',
    },
  ];

  function handleClaimPeriodChange(value: TreatmentPeriodOption['value']) {
    // if (value) {
    setSelectedTreatmentPeriod(value);
    // }
    onChange((state) => ({
      ...state,
      treatmentPeriod: value ? value : undefined,
    }));
  }

  return (
    <Select
      value={selectedTreatmentPeriod}
      style={{ width: 210 }}
      placeholder={t('enum.treatmentPeriod.ALL_TIME')}
      onChange={handleClaimPeriodChange}
    >
      {treatmentPeriodOptions.map(({ label, value }) => (
        <Option key={value} value={value}>
          {label}
        </Option>
      ))}
    </Select>
  );
};

export default TreatmentPeriodDropdown;
